(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

var init = require('./lib/init');
var update = require('./lib/update');
window.onload = function() {
    init.init();
    function animate() {
        update.update();
        update.render();
        requestAnimationFrame(animate);
    }
    animate();
};

},{"./lib/init":3,"./lib/update":6}],2:[function(require,module,exports){
'use strict';

// canvas elements
exports.image = document.getElementById('source');
exports.canvas = document.getElementById('canvas');
exports.targetCanvas = document.getElementById('target');
// context
exports.context = exports.canvas.getContext('2d');
exports.targetContext = exports.targetCanvas.getContext('2d');
// dimensions
exports.width = exports.canvas.width = exports.targetCanvas.width = window.innerWidth;
exports.height = exports.canvas.height = exports.targetCanvas.height = window.innerHeight;
exports.centerX = exports.width / 2;
exports.centerY = exports.height / 2;
exports.centerXAdjusted = exports.centerX - 150; // 150 is half the target image's width
exports.centerYAdjusted = exports.centerY - 150; // same for height
// global variables, objects and arrays
exports.particleArr = [];
exports.mouse = {};
document.body.addEventListener("mousemove", function(event) {
    exports.mouse.x = event.clientX;
    exports.mouse.y = event.clientY;
});
document.body.addEventListener("touchstart", function(event) {
    exports.mouse.x = event.changedTouches[0].clientX;
    exports.mouse.y = event.changedTouches[0].clientY;
}, false);
document.body.addEventListener("touchmove", function(event) {
    event.preventDefault();
    exports.mouse.x = event.targetTouches[0].clientX;
    exports.mouse.y = event.targetTouches[0].clientY;
}, false);
document.body.addEventListener("touchend", function(event) {
    event.preventDefault();
    exports.mouse.x = 1;
    exports.mouse.y = 1;
}, false);
window.onresize = function() {
    location.reload();
};
exports.mouseRadius = Math.pow(100, 2);
exports.friction = 0.95;
exports.ease = 0.25;

},{}],3:[function(require,module,exports){
'use strict';

var canvas = require('./canvas');
var Particle = require('./particle');
var Orbit = require('./orbit');

exports.init = function() {
    // init logo & it's data
    canvas.targetContext.drawImage(canvas.image, canvas.centerXAdjusted, canvas.centerYAdjusted);
    var pixels = canvas.targetContext.getImageData(0, 0, canvas.width, canvas.height).data;
    // init orbit
    exports.ball = new Orbit(0.01, 0, 350);
    // init particle array
    var index;
    for (var y = 0, h = canvas.height; y < h; y += 3) {
        for (var x = 0, w = canvas.width; x < w; x += 3) {
            index = (y * w + x) * 4;
            if(pixels[++index] > 0) {
                canvas.particleArr.push(new Particle(x, y));
            }
        }
    }
};

},{"./canvas":2,"./orbit":4,"./particle":5}],4:[function(require,module,exports){
'use strict';

function Ball(speed, angle, radius, x, y) {
    this.x = x;
    this.y = y;
    this.speed = speed;
    this.angle = angle;
    this.radius = radius;
}
Ball.prototype.update = function(centerX, centerY) {
    this.x = centerX + Math.cos(this.angle) * this.radius;
    this.y = centerY + Math.sin(this.angle) * this.radius;
};
Ball.prototype.adjustAngle = function() {
    this.angle += this.speed;
};
module.exports = Ball;

},{}],5:[function(require,module,exports){
'use strict';

function Particle (x, y) {
    this.x = this.originX = x;
    this.y = this.originY = y;
    this.rx = 0;
    this.ry = 0;
    this.vx = 0;
    this.vy = 0;
    this.force = 0;
    this.angle = 0;
    this.distance = 0;
}
Particle.prototype.update = function(mx, my, mr, f, e) {
    this.rx = mx - this.x;
    this.ry = my - this.y;
    this.distance = this.rx * this.rx + this.ry * this.ry;
    this.force = -mr / this.distance;
    if(this.distance < mr) {
        this.angle = Math.atan2(this.ry, this.rx);
        this.vx += this.force * Math.cos(this.angle);
        this.vy += this.force * Math.sin(this.angle);
    }
    this.x += (this.vx *= f) + (this.originX - this.x) * e;
    this.y += (this.vy *= f) + (this.originY - this.y) * e;
};
module.exports = Particle;

},{}],6:[function(require,module,exports){
'use strict';

var utility = require('./utils');
var canvas = require('./canvas');
var init = require('./init');

exports.update = function () {
    for(var i = 0, j = canvas.particleArr.length; i < j; i++) {
        var p = canvas.particleArr[i];
        //if(utility.utils.randomInt(1, 100) < 20) {
        //    p.x = utility.utils.randomInt(p.originX - 5, p.originX + 5);
        //    p.y = utility.utils.randomInt(p.originY - 5, p.originY + 5);
        //}
        p.update(canvas.mouse.x, canvas.mouse.y, canvas.mouseRadius, canvas.friction, canvas.ease);
    }
    init.ball.update(canvas.centerX, canvas.centerY);
};
exports.render = function() {
    canvas.context.clearRect(0, 0, canvas.width, canvas.height);
    for(var i = 0, j = canvas.particleArr.length; i < j; i++) {
        var p = canvas.particleArr[i];
        canvas.context.fillStyle = "#505050";
        canvas.context.fillRect(p.x, p.y, 2, 2);
    }
    canvas.context.beginPath();
    canvas.context.arc(init.ball.x, init.ball.y, 3, 0, Math.PI * 2, false);
    canvas.context.fillStyle = "#505050";
    canvas.context.fill();
    init.ball.adjustAngle();
};

},{"./canvas":2,"./init":3,"./utils":7}],7:[function(require,module,exports){
"use strict";

exports.utils = {
    randomInt: function(min, max) {
        return Math.floor(min + Math.random() * (max - min + 1));
    }
};

},{}]},{},[1]);
